import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import './CashCalculator.css'

// Valeurs en centimes pour éviter les erreurs d'arrondi flottant
const DENOMINATIONS = [
	{ cents: 1, label: '1 ct', type: 'Pièce' },
	{ cents: 2, label: '2 ct', type: 'Pièce' },
	{ cents: 5, label: '5 ct', type: 'Pièce' },
	{ cents: 10, label: '10 ct', type: 'Pièce' },
	{ cents: 20, label: '20 ct', type: 'Pièce' },
	{ cents: 50, label: '50 ct', type: 'Pièce' },
	{ cents: 100, label: '1 €', type: 'Pièce' },
	{ cents: 200, label: '2 €', type: 'Pièce' },
	{ cents: 500, label: '5 €', type: 'Billet' },
	{ cents: 1000, label: '10 €', type: 'Billet' },
	{ cents: 2000, label: '20 €', type: 'Billet' },
	{ cents: 5000, label: '50 €', type: 'Billet' },
	{ cents: 10000, label: '100 €', type: 'Billet' },
	{ cents: 20000, label: '200 €', type: 'Billet' },
	{ cents: 50000, label: '500 €', type: 'Billet' }
]

class CashCalculator extends Component {

	constructor(props) {
		super(props)
		this.state = {
			quantities: DENOMINATIONS.map(() => '')
		}
	}

	componentDidMount() {
		if (this.props.updateNavbarTitle)
			this.props.updateNavbarTitle('Calculatrice d\'espèces')
	}

	_setQuantity = (idx, value) => {
		const quantities = [...this.state.quantities]
		quantities[idx] = value
		this.setState({ quantities })
	}

	_rowCents = (idx) => {
		const qty = parseInt(this.state.quantities[idx], 10)
		if (isNaN(qty) || qty < 0)
			return 0
		return DENOMINATIONS[idx].cents * qty
	}

	_totalCents = () => {
		let total = 0
		for (let i = 0; i < DENOMINATIONS.length; i++)
			total += this._rowCents(i)
		return total
	}

	_formatEuros = (cents) => {
		return (cents / 100).toFixed(2).replace('.', ',') + ' €'
	}

	_reset = () => {
		this.setState({ quantities: DENOMINATIONS.map(() => '') })
	}

	_renderTable = (type, title) => {
		const rows = DENOMINATIONS.map((d, idx) => ({ ...d, idx })).filter((d) => d.type === type)
		let subtotal = 0
		for (let i = 0; i < rows.length; i++)
			subtotal += this._rowCents(rows[i].idx)
		return (
			<div className="bg-white rounded-2xl shadow-sm overflow-hidden">
				<div className="px-5 py-4 border-b border-gray-100">
					<h2 className="text-base font-bold text-gray-900">{title}</h2>
				</div>
				<table className="w-full">
					<thead>
						<tr className="border-b border-gray-100">
							<th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-tight">{type}</th>
							<th className="px-5 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-tight">Quantité</th>
							<th className="px-5 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-tight">Total</th>
						</tr>
					</thead>
					<tbody className="divide-y divide-gray-50">
						{rows.map((d) => {
							const rowCents = this._rowCents(d.idx)
							return (
								<tr key={d.cents}>
									<td className="px-5 py-2.5">
										<span className={`inline-flex items-center justify-center text-base font-semibold px-2.5 py-0.5 rounded-full ${d.type === 'Pièce' ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}`}>
											{d.label}
										</span>
									</td>
									<td className="px-5 py-2.5 text-center">
										<input
											type="number" min="0" step="1"
											value={this.state.quantities[d.idx]}
											onChange={(e) => this._setQuantity(d.idx, e.target.value)}
											placeholder="0"
										/>
									</td>
									<td className={`px-5 py-2.5 text-right text-base font-semibold tabular-nums ${rowCents > 0 ? 'text-gray-900' : 'text-gray-300'}`}>
										{this._formatEuros(rowCents)}
									</td>
								</tr>
							)
						})}
					</tbody>
					<tfoot>
						<tr className="border-t-2 border-gray-200 bg-gray-50">
							<td className="px-5 py-3 text-base font-bold text-gray-900" colSpan={2}>Sous-total</td>
							<td className="px-5 py-3 text-right text-base font-bold text-gray-900 tabular-nums">
								{this._formatEuros(subtotal)}
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		)
	}

	render() {
		if (this.props.features !== 'premium')
			return (<Redirect to="/" />)

		const total = this._totalCents()
		return (
			<div className="cash-calc max-w-4xl mx-auto px-4 py-6">
				<div className="flex items-center justify-between mb-4">
					<button
						onClick={() => this.props.history.push('/services/commandes')}
						className="flex items-center gap-2 text-sm font-semibold text-gray-500 hover:text-indigo-600 transition-colors"
						style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
					>
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
						</svg>
						Retour aux commandes
					</button>
					<button
						onClick={this._reset}
						className="text-sm font-semibold text-gray-500 hover:text-red-600 border border-gray-200 px-3 py-1.5 rounded-lg hover:border-red-300 transition-colors"
						style={{ backgroundImage: 'none', backgroundColor: '#ffffff' }}
					>
						Réinitialiser
					</button>
				</div>
				<div className="mb-4">
					<h2 className="text-base font-bold text-gray-900">Calculatrice d'espèces</h2>
					<p className="text-base text-gray-400 mt-0.5">Saisissez le nombre de pièces et de billets pour compter la caisse.</p>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
					{this._renderTable('Pièce', 'Pièces')}
					{this._renderTable('Billet', 'Billets')}
				</div>
				<div className="bg-white rounded-2xl shadow-sm mt-4 px-5 py-4 flex items-center justify-between">
					<span className="text-base font-bold text-gray-900">Total</span>
					<span className="text-lg font-bold text-indigo-600 tabular-nums">{this._formatEuros(total)}</span>
				</div>
			</div>
		)
	}
}

export default CashCalculator
